// hooks/useCreateAnnouncement.ts
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  CreateAnnouncementResponse,
  CreateResidentAnnouncementPayload,
} from '../types/dashboard';
import { residentDashboardApis } from '../api';

export const useCreateAnnouncement = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CreateAnnouncementResponse,
    Error,
    CreateResidentAnnouncementPayload
  >({
    mutationFn: (payload) => residentDashboardApis.createAnnouncement(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['residentAnnouncementOverview'],
      });
      queryClient.invalidateQueries({
        queryKey: ['residentAnnouncements'],
      });
    },
  });
};
